<template>
  <div
    :class="{ 'item-boxes': !scrollable, 'item-boxes--scrollable': scrollable }"
  >
    <ItemSkuBox
      v-for="itemSku in itemSkus"
      :key="itemSku.id"
      :link-url="itemSku.linkUrl"
      :image-url="itemSku.imageUrl"
      :brand-name="itemSku.brandName"
      :item-name="itemSku.itemName"
      :item-sku-name="itemSku.itemSkuName"
      :item-sku-price="itemSku.itemSkuPrice"
      :is-including-tax="itemSku.isIncludingTax"
      :has-multiple-item-skus="itemSku.hasMultipleItemSkus"
      :show-add-button="itemSku.showAddButton"
      :add-button-text="itemSku.addButtonText"
      @clicked-add-button="clickAddButton(itemSku.itemId, itemSku.id)"
      @clicked-link="clickLink(itemSku.id)"
    />
  </div>
</template>
<script>
import ItemSkuBox from '../../atoms/item_boxes/ItemSkuBox.vue'
export default {
  components: { ItemSkuBox },
  props: {
    itemSkus: {
      type: Array,
      required: true
    },
    scrollable: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$emit('mount')
    })
  },
  methods: {
    clickAddButton(itemId, itemSkuId) {
      this.$emit('clicked-add-button', itemId, itemSkuId)
    },
    clickLink(itemSkuId) {
      this.$emit('clicked-link', itemSkuId)
    }
  }
}
</script>
